import { render, staticRenderFns } from "./promote.vue?vue&type=template&id=f22cb6aa"
import script from "./promote.vue?vue&type=script&lang=ts"
export * from "./promote.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports